var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWebCopy2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C76306",
    d: "M11 0C4.934 0 0 4.934 0 11s4.934 11 11 11 11-4.934 11-11S17.066 0 11 0m0 1.5c5.247 0 9.5 4.253 9.5 9.5s-4.253 9.5-9.5 9.5-9.5-4.253-9.5-9.5S5.753 1.5 11 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C76306",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11 1c3.484 1.67 6 6.016 6 10 0 3.818-2.61 8.201-6 10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C76306",
    d: "M11 1C7.965 2.67 6 7.016 6 11c0 3.818 2.047 8.201 5 10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C76306",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11 1v20M21 10.5H1"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWebCopy2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/web-copy-2.42fea325.svg";
export { ForwardRef as ReactComponent };